import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import neuBirdLogo from "../assets/NeuBird-Horizontal-Default.svg";

const API_URL = process.env.REACT_APP_API_URL || "";
const POLL_INTERVAL = 5000;

const ProvisioningPage = () => {
  const [status, setStatus] = useState("provisioning");
  const [loginUrl, setLoginUrl] = useState("");
  const [error, setError] = useState("");
  const pollRef = useRef(null);

  useEffect(() => {
    const registrationId = localStorage.getItem("earlybird_registration_id");
    if (!registrationId) {
      setError("Missing registration information. Please register again.");
      return;
    }

    const poll = async () => {
      try {
        const resp = await axios.get(
          `${API_URL}/earlybird/status`,
          { params: { id: registrationId } }
        );

        const data = resp.data;
        setStatus(data.status);

        if (data.status === "ready" && data.login_url) {
          setLoginUrl(data.login_url);
          if (pollRef.current) clearInterval(pollRef.current);
          localStorage.removeItem("earlybird_registration_id");
          setTimeout(() => {
            window.location.href = data.login_url;
          }, 3000);
        } else if (data.status === "failed") {
          if (pollRef.current) clearInterval(pollRef.current);
          setError("Workspace setup encountered an issue. Please contact support at sre@neubird.ai.");
        }
      } catch (err) {
        console.error("Status poll error:", err);
      }
    };

    poll();
    pollRef.current = setInterval(poll, POLL_INTERVAL);
    return () => { if (pollRef.current) clearInterval(pollRef.current); };
  }, []);

  return (
    <>
      <nav className="site-nav">
        <a className="nav-logo" href="https://neubird.ai">
          <img src={neuBirdLogo} alt="NeuBird AI" />
        </a>
      </nav>

      <div className="success-page">
        <div className="success-card">
          {error ? (
            <>
              <div className="success-icon" style={{ background: "rgba(231,76,60,0.15)", color: "#e74c3c" }}>!</div>
              <h2>Setup Issue</h2>
              <p>{error}</p>
            </>
          ) : status === "ready" ? (
            <>
              <div className="success-icon">&#10003;</div>
              <h2>Your workspace is ready!</h2>
              <p>Redirecting you to login...</p>
              {loginUrl && (
                <p style={{ marginTop: "1rem" }}>
                  <a href={loginUrl} style={{ color: "var(--sunset)", fontWeight: 600 }}>
                    Click here if you're not redirected
                  </a>
                </p>
              )}
            </>
          ) : (
            <>
              <div className="provisioning-spinner"></div>
              <h2>Setting up your NewBird workspace...</h2>
              <p>This usually takes 2–5 minutes. You can wait here — we'll redirect you automatically when it's ready.</p>
              <div className="provisioning-steps">
                <div className="tp-step">
                  <div className="tp-num" style={{ background: "var(--lime)", color: "var(--canopy)" }}>&#10003;</div>
                  <div className="tp-text">Account created</div>
                </div>
                <div className="tp-step">
                  <div className="tp-num">2</div>
                  <div className="tp-text">Provisioning workspace <span className="tp-time">in progress...</span></div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <footer className="site-footer">
        <span className="footer-text">&copy; 2026 NeuBird AI, Inc.</span>
        <div className="footer-links">
          <a href="https://neubird.ai/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
          <a href="https://neubird.ai/terms" target="_blank" rel="noopener noreferrer">Terms</a>
          <a href="https://neubird.ai/security" target="_blank" rel="noopener noreferrer">Security</a>
          <a href="https://neubird.ai/contact" target="_blank" rel="noopener noreferrer">Contact</a>
        </div>
      </footer>
    </>
  );
};

export default ProvisioningPage;
